import React from "react";
import {Colors} from "../colors";

interface IconKeyProps {
  color?: string;
  size?: number;
}

export const IconKey: React.FC<IconKeyProps> = ({color = Colors.primary._300, size = 24}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.6314 7.63137C15.2354 7.23535 15.0373 7.03735 14.9632 6.80902C14.8979 6.60817 14.8979 6.39183 14.9632 6.19098C15.0373 5.96265 15.2354 5.76465 15.6314 5.36863L18.4697 2.53026C17.7165 2.18962 16.8804 2 16 2C12.6863 2 10 4.68629 10 8C10 8.49104 10.059 8.9683 10.1703 9.42509C10.2894 9.91424 10.349 10.1588 10.3384 10.3133C10.3273 10.4751 10.3032 10.5612 10.2286 10.7051C10.1574 10.8426 10.0209 10.9791 9.74782 11.2522L3.5 17.5C2.67157 18.3284 2.67157 19.6716 3.5 20.5C4.32842 21.3284 5.67157 21.3284 6.5 20.5L12.7478 14.2522C13.0209 13.9791 13.1574 13.8426 13.2949 13.7714C13.4388 13.6968 13.5249 13.6727 13.6867 13.6616C13.8412 13.651 14.0858 13.7106 14.5749 13.8297C15.0317 13.941 15.509 14 16 14C19.3137 14 22 11.3137 22 8C22 7.11959 21.8104 6.28347 21.4697 5.53026L18.6314 8.36863C18.2354 8.76465 18.0373 8.96265 17.809 9.03684C17.6082 9.1021 17.3918 9.1021 17.191 9.03684C16.9627 8.96265 16.7646 8.76465 16.3686 8.36863L15.6314 7.63137Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
